import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/contact-info.scss';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import EditIcon from 'src/Admin/img/myProfile/EditIcon';
import { useSelector } from 'react-redux';
import MasterPermissions from '../../../../api/MasterPermissions';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';

const ContactInfo = ({
  residentialAddress,
  mailingAddress,
  PhoneEmailInfo,
  loader,
  onClickEdit,
  showEditButton = true,
}) => {
  const { t } = useTranslation();
  const noValue = 'Not Specified';

  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }

  const getAddressLine = (address) => {
    return `${address?.Address1} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City : ''}, ${
      address?.State ? address?.State : ''
    }`;
  };

  const getAddressLineZip = (address) => {
    return `${address?.PostalCode} ${address?.Country} `;
  };
  const residential_address =
    residentialAddress && residentialAddress
      ? getAddressLine(residentialAddress)
      : noValue;
  const residential_address_zip =
    residentialAddress && residentialAddress
      ? getAddressLineZip(residentialAddress)
      : '';
  const mailing_address =
    mailingAddress && mailingAddress?.Address1
      ? getAddressLine(mailingAddress)
      : noValue;
  const mailing_address_zip =
    mailingAddress && mailingAddress?.Address1
      ? getAddressLineZip(mailingAddress)
      : '';

  return loader ? (
    <p>loading</p>
  ) : (
    <div className="contact-info-section">
      <div className="top-header-container">
        <div className="title">
          {t('member.pages.my_profile.labels.contact_information')}
        </div>
        {showEditButton &&
          (MasterPermissions.CheckPermission(
            'Edit Member Contact Information',
          ) ||
            MasterPermissions.CheckPermission(
              'Edit Member Address Information',
            )) && (
            <div>
              <GenericButton
                variant="secondary"
                onClick={() => {
                  onClickEdit(true);
                }}
              >
                <EditIcon
                  fillColor={themeValuesObject['Secondary-1'] || '#1d90ba'}
                />{' '}
                Edit
              </GenericButton>
            </div>
          )}
      </div>
      <div className="error-message-container">
        <GenericMessage
          wrapperClasses="mt-3 msg-txt"
          message={t('member.pages.my_profile.labels.message')}
          messageType={'info'}
          showMessage={true}
          hideCloseButton={true}
        />
      </div>
      <div className="pt-2 contact-container">
        <div className="first-column">
          <div>
            <label>{t('member.common_labels.email')}</label>
            <span className="plain-text ">
              {PhoneEmailInfo?.Email1 || noValue}
            </span>
          </div>
          <div>
            <label>{t('member.common_labels.alternate_email')}</label>
            <span className="plain-text ">
              {PhoneEmailInfo?.Email2 || noValue}
            </span>
          </div>
          <div>
            <label>{t('member.pages.my_profile.labels.home_phone')}</label>
            <span className="plain-text ">
              {PhoneEmailInfo?.HomePhone || noValue}
            </span>
          </div>
          <div>
            <label>{t('member.pages.my_profile.labels.work_phone')}</label>
            <span className="plain-text ">
              {PhoneEmailInfo?.WorkPhone || noValue}
            </span>
          </div>
          <div>
            <label>{t('member.pages.my_profile.labels.mobile_phone')}</label>
            <span className="plain-text ">
              {PhoneEmailInfo?.MobilePhone || noValue}
            </span>
          </div>
        </div>

        <div className="second-column">
          <div>
            <label>{t('member.common_labels.residential_address')}</label>
            <span className="plain-text ">
              {residential_address}
              <br />
              {residential_address_zip}
            </span>
          </div>
          <div>
            <label>{t('member.common_labels.mailing_address')}</label>
            <span className="plain-text ">
              {mailing_address}
              <br />
              {mailing_address_zip}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
